"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetFreeKeysModal = void 0;
const Dialog_1 = require("root/src/client/v2/common/components/modal/Dialog");
const ModalTitle_1 = require("root/src/client/v2/common/components/modal/ModalTitle");
const BulletItem_1 = require("root/src/client/v2/common/components/list/BulletItem");
const BulletList_1 = require("root/src/client/v2/common/components/list/BulletList");
const ModalBottomText_1 = require("root/src/client/v2/creatorOnboarding/ModalBottomText");
const commonStyles_1 = require("root/src/client/web/commonStyles");
const modal_context_1 = require("root/src/client/v2/common/contexts/modal-context");
const routeUrls_1 = require("root/src/shared/descriptions/routes/routeUrls");
const Link_1 = __importDefault(require("root/src/client/web/base/Link"));
const react_vimeo_1 = __importDefault(require("@u-wave/react-vimeo"));
const constants_1 = require("root/src/client/v2/creatorOnboarding/constants");
function GetFreeKeysModal() {
    return (<Dialog_1.Dialog className="sm:w-[700px]">
			<ModalTitle_1.ModalTitle>Do Drops to Get Keys</ModalTitle_1.ModalTitle>
			<Video />
			<Instructions />
			<ModalBottomText_1.BottomText />
		</Dialog_1.Dialog>);
}
exports.GetFreeKeysModal = GetFreeKeysModal;
function Video() {
    return (<react_vimeo_1.default video={constants_1.GET_STARTED_VIDEO} responsive/>);
}
function Instructions() {
    return (<BulletList_1.BulletList>
			<BulletItem_1.BulletItem color={commonStyles_1.colorsNew.teal}>
				To earn keys for your audience, go to the <DropsLink /> page (link in nav bar) and select a game you want to play.
				Accept one of the dares from that Drop’s page.
			</BulletItem_1.BulletItem>
			<BulletItem_1.BulletItem color={commonStyles_1.colorsNew.primary}>
				Make content for your community on your connected channel (Twitch, YouTube, or TikTok).
			</BulletItem_1.BulletItem>
			<BulletItem_1.BulletItem color={commonStyles_1.colorsNew.yellow}>
				On your Dare Drop profile Deliver a clip or video of you completing the dare to get the rewards listed.
			</BulletItem_1.BulletItem>
		</BulletList_1.BulletList>);
}
function DropsLink() {
    const { hide } = (0, modal_context_1.useModal)();
    return (<Link_1.default onClick={hide} href={routeUrls_1.routeUrls.drops()}>Drops</Link_1.default>);
}
